import * as React from 'react';
import { InputRoot, InputText, ImageStyled, SpanStyled } from './InputStyle.js';

function Input({ span = null, icon = null, onClickIcon = () => { }, ...rest }) {
  return (
    <InputRoot >
      {icon ? <ImageStyled src={icon} alt='img-first-btn' /> : null}
      <InputText {...rest} />
      {span ? <SpanStyled onClick={onClickIcon}>{span}</SpanStyled> : null}
    </InputRoot>
  );
}

export default Input;